import CheckboxGroup from '@admin/components/form/checkboxgroup'
import PropTypes from 'prop-types'
import React from 'react'

const options = [
  { value: 'referral_team_created', text: 't(a new referral signs up through my affiliate singup page)' },
  { value: 'referral_trial_started', text: 't(a referral is set up and beings their free trial)' },
  { value: 'referral_trial_ended', text: 't(a referral completes their free trial and is charged for their first month)' },
  { value: 'referral_subscription_canceled', text: 't(a referral cancels their subscription)' },
  { value: 'payout_issued', text: 't(a new commission payout is issued)' }
]

class AffiliateNotificationsField extends React.PureComponent {

  static propTypes = {
    channel: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    onReady: PropTypes.func
  }

  state = {
    notifications: []
  }

  _handleUpdate = this._handleUpdate.bind(this)

  render() {
    return <CheckboxGroup { ...this._getCheckboxGroup() } />
  }

  componentDidMount() {
    const { value } = this.props
    this._handleSet(value)
    this.props.onReady()
  }

  componentDidUpdate(prevProps, prevState) {
    const { notifications } = this.state
    if(notifications !== prevState.notifications) {
      this._handleChange()
    }
  }

  _getCheckboxGroup() {
    const { notifications } = this.state
    return {
      label: 't(Notify me when)',
      name: 'notifications',
      type: 'checkboxgroup',
      options,
      defaultValue: options.map(notification => notification.value),
      value: notifications,
      deselectable: true,
      onChange: this._handleUpdate
    }
  }

  _handleChange() {
    const { notifications } = this.state
    this.props.onChange(options.reduce((options, option) => ({
      ...options,
      [option.value]: notifications.includes(option.value)
    }), {}))
  }

  _handleSet(notifications) {
    this.setState({
      notifications: notifications ? Object.keys(notifications).filter(key => notifications[key]) : [
        ...options.map(option => option.value)
      ]
    })
  }

  _handleUpdate(notifications) {
    this.setState({ notifications })
  }

}

export default AffiliateNotificationsField
